export { default } from './commandCenterAnnouncementsAdmin.reducer';
